<!--
 * @Author: Louis
 * @Date: 2020-02-18 17:27:56
 * @LastEditors: Louis
 * @LastEditTime: 2020-02-18 18:11:20
 * @Description:
 -->
<template>
  <div class="main-components">
    <components  :disabled="disabled" :is="browserType" :list="value" :commondata="commondata" @change="changeValueInfo"></components>
    <!-- 详情信息 -->
    <en-details
      v-model="showDetails"
      :content="contentValue"
    >
    </en-details>
  </div>
</template>
<script>
import MOBILE from "./../mobileComponents";
import PC from "./../pcComponents";
import enDetails from "./../en-details";

export default {
  props: {
    browserType: {
      default: "PC"
    },
    commondata: Object,
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MOBILE,
    PC,
    enDetails
  },
  data() {
    return {
      provinceList: [],
      cityList: [],
      districtList: [],
      cityKey: {},
      fileList: [],
      showDetails: false,
      timeOut: null,
      contentValue: null
    };
  },
  methods: {
    changeValueInfo(itemData) {
      this.$emit("change", itemData);
    }
  }
};
</script>
<style lang="scss">
</style>
